<form>
    <div class="input-container">
        <input type="text" (click)="dropdownList()" #select [style]="style" [placeholder]=placeholder matInput
            [matAutocomplete]="auto" [formControl]="optionCtrl" #autocompleteInput />
        <span><mat-icon class="arrow-selector" matSuffix matInput
                (click)="openAutocomplete()">arrow_drop_down</mat-icon></span>
    </div>
    <mat-autocomplete (optionSelected)="onSelectionChange($event)" autoActiveFirstOption #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions" [value]="option" [value]="option">
            <span [matTooltip]="option.name || option" class="word-break">{{
                option.name || option
                }}</span>
        </mat-option>
    </mat-autocomplete>
</form>